import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Search } from 'UI';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useRouteMatch } from 'react-router';

import {
  MainContainer,
  SearchContainer,
} from './style';

interface ClientsListExtraProps {
  onSearch(content: string): void
}

const ClientsListExtra = ({
  onSearch,
}: ClientsListExtraProps): JSX.Element => {
  const { url } = useRouteMatch();
  const breadcrumbNavigator = useBreadcrumbNavigation();

  return (
    <MainContainer>
      <SearchContainer>
        <Search placeholder="Buscar cliente" onSearch={onSearch} allowClear />
      </SearchContainer>
      <Button
        icon={<PlusOutlined size={14} />}
        onClick={() => breadcrumbNavigator.push({
          label: 'Cadastrar novo cliente',
          url: `${url}/Novo`,
        })}
      >
        Cadastrar novo cliente
      </Button>
      {/* TODO: add inactive filter switch */}
    </MainContainer>
  );
};

export default ClientsListExtra;
